import { Content } from "@/components/Content";
import { createTitle } from "@/functions/createTitle";
import * as additionalComponents from "./__components";
import { Collection } from "@sourceflow-uk/sourceflow-sdk";
import { getExpertise } from "@/getters/getExpertise";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const expertise = getExpertise({ url_slug });

  return {
    props: {
      meta: {
        title: createTitle(expertise.title, "Expertise"),
      },
      content: [
        { component: "Banner", props: { className: "", ...expertise } },
        { component: "Intro", props: { className: "", ...expertise } },
        {
          component: "SystemsCarousel",
          props: { className: "", matcher: expertise.systems.split(", "), ...expertise },
        },
        { component: "RolesFeed", props: { className: "", matcher: expertise.roles.split(", ") } },
        { component: "Content", props: { className: "", ...expertise } },
        { component: "Statistics", props: { className: "py-4" } },
        { component: "TeamCTA", props: { className: "", page: expertise.url_slug } },
        { component: "CommunityCTA", props: { className: "" } },
      ],
    },
  };
}

export async function getStaticPaths() {
  return {
    paths: (await Collection("expertise")).getPaths("url_slug"),
    fallback: false,
  };
}
